// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__5f19T","body":"Layout_body__DEG3X"};